import { useMutation, useQueryClient } from 'react-query'
import { removeUser } from 'services/api'
import { WebApiError } from 'types/general'
import { RemoveUserData } from 'services/api/endpoints/backendAPI/removeUser'
import { useSnackbar } from 'notistack'

export function useRemoveUser() {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation<Response, WebApiError, RemoveUserData>(removeUser, {
    onSuccess: () => {
      queryClient.refetchQueries('allUsers')
    },
    onError: (err) => {
      enqueueSnackbar(`${err?.response?.data?.error?.message}`, {
        variant: 'error',
      })
    },
  })
}
